import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AccountantDateRange,
  AccountantOrderItem,
  AccountantOrders,
  AccountantReportQuery,
  AccountantReturnItem,
  AccountantShippingCompany,
  AccountantSummaryPayload,
  SummaryResponse
} from '../../../models/admin/accountant.model';
import { SubmitResponse } from '../../../models/common/api-response.model';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class AccountantService extends HttpService<any, SummaryResponse | AccountantOrders> {

  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'report/accountant');
  }

  getSummary(payload: AccountantSummaryPayload): Observable<SummaryResponse> {
    return this.filterAllRports(payload, 'summary') as Observable<SummaryResponse>;
  }

  exportOrders(payload: AccountantSummaryPayload): Observable<Blob> {
    return this.downloadFileWithParams('report/accountant/export', payload) as Observable<Blob>;
  }

  getShippingCompanies(): Observable<AccountantShippingCompany[]> {
    return this.getAll('shipping-companies') as unknown as Observable<AccountantShippingCompany[]>;
  }

  getAllOrders(payload: any): Observable<AccountantOrders> {
    return this.filterAllRports(payload, 'orders') as unknown as Observable<AccountantOrders>;
  }

  updateBulkOrderStatus(payload: any): Observable<SubmitResponse> {
    return this.patchWithID(payload, 'orders/bulk-update') as unknown as Observable<SubmitResponse>;
  }

  updateTrackingNumber(payload: any, id: string): Observable<SubmitResponse> {
    return this.patchWithID(payload, `orders/${id}/tracking`) as unknown as Observable<SubmitResponse>;
  }

  updateDeliveryCharge(payload: { delivery_charge: number }, id: string): Observable<SubmitResponse> {
    return this.patchWithID(payload, `orders/${id}/delivery-charge`) as unknown as Observable<SubmitResponse>;
  }

  updateReturnDeliveryCharge(payload: { delivery_charge: number }, return_id: string): Observable<SubmitResponse> {
    return this.patchWithID(payload, `returns/${return_id}/delivery-charge`) as unknown as Observable<SubmitResponse>;
  }

  updateOrderNote(payload: { note: string }, id: string): Observable<SubmitResponse> {
    return this.patchWithID(payload, `orders/${id}/note`) as unknown as Observable<SubmitResponse>;
  }

  updateReturnNote(payload: { note: string }, return_id: string): Observable<SubmitResponse> {
    return this.patchWithID(payload, `returns/${return_id}/note`) as unknown as Observable<SubmitResponse>;
  }

  updateReturnTrackingNumber(payload: { tracking_number: string }, return_id: string): Observable<SubmitResponse> {
    return this.patchWithID(payload, `returns/${return_id}/tracking`) as unknown as Observable<SubmitResponse>;
  }

  getSingleOrderDetails(id: string): Observable<AccountantOrderItem[]> {
    return this.getById(id, 'orders', 'items') as unknown as Observable<AccountantOrderItem[]>;
  }

  getSingleOrderReturns(return_id: string): Observable<AccountantReturnItem[]> {
    return this.getById(return_id, 'returns', 'items') as unknown as Observable<AccountantReturnItem[]>;
  }
}
